import { forwardRef, PropsWithChildren } from 'react';

interface PopupActionProps extends PropsWithChildren {
  onClick: () => void;
  className: string;
  dataCy?: string;
}

const PopupActionView = forwardRef<HTMLButtonElement, PopupActionProps>(
  ({ onClick, className, dataCy, children }, ref) => {
    return (
      <button
        ref={ref}
        className={className}
        onClick={onClick}
        data-cy={dataCy}
      >
        {children}
      </button>
    );
  },
);

export default PopupActionView;
